var map = {
	"./angle-down.svg": 1149,
	"./arrow-down.svg": 1150,
	"./arrow-triangle-fill-down.svg": 1151,
	"./arrow-triangle-fill-up.svg": 1152,
	"./bar-line.svg": 596,
	"./check.svg": 1153,
	"./clock.svg": 562,
	"./cross.svg": 1154,
	"./download-line.svg": 597,
	"./email-line.svg": 1155,
	"./file-line.svg": 1156,
	"./filter.svg": 1157,
	"./folder.svg": 561,
	"./folder2.svg": 1158,
	"./garph-line.svg": 598,
	"./image.svg": 1159,
	"./pdf.svg": 1160,
	"./printer-line.svg": 1161,
	"./push-icon.svg": 220,
	"./report-line.svg": 1162,
	"./sort-arrow-down.svg": 214,
	"./sort-arrow-up.svg": 215,
	"./star.svg": 1163,
	"./trash.svg": 1164,
	"./triangle-fill-down.svg": 1165,
	"./updated-file.svg": 194,
	"./upload-img.svg": 599
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1148;